/**
 * A single detail row inside a CollapsibleRiskCard: leading action icon, name, supporting line
 * and an optional trailing element (risk chip, rating bar or action button).
 */
import { IconButton, Stack, Tooltip, Typography } from '@mui/material'
import React from 'react'

const ICON_SLOT_WIDTH = 30

export interface RiskCardListItemProps {
  name: string
  supportingText: string
  icon?: React.ReactNode
  iconLabel?: string
  onIconClick?: () => void
  trailingElement?: React.ReactNode
}

export const RiskCardListItem: React.FC<RiskCardListItemProps> = ({
  name,
  supportingText,
  icon,
  iconLabel,
  onIconClick,
  trailingElement,
}) => (
  <Stack direction="row" alignItems="flex-start" spacing={1}>
    {/* Reserved even without an icon so every row's text starts on the same line. */}
    <Stack width={ICON_SLOT_WIDTH} flexShrink={0}>
      {icon && (
        <Tooltip arrow title={iconLabel}>
          <span>
            <IconButton size="small" aria-label={iconLabel} onClick={onIconClick} disabled={!onIconClick}>
              {icon}
            </IconButton>
          </span>
        </Tooltip>
      )}
    </Stack>
    <Stack flexGrow={1} minWidth={0}>
      <Typography variant="body2" color="text.primary">
        {name}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {supportingText}
      </Typography>
    </Stack>
    {trailingElement}
  </Stack>
)

export default RiskCardListItem
